import React, { useEffect } from 'react';
import ReactGA from 'react-ga';
import { NamesProvider } from 'contexts/names.context';
import { ThemeProvider } from '@material-ui/core/styles';
import { CssBaseline } from '@material-ui/core';
import Theme from '../styles/theme';
import useStyles from '../styles/global';
import { AppProps } from 'next/app';

export default function MyApp({ Component, pageProps, router }: AppProps) {
  const classes = useStyles();

  useEffect(() => {
    ReactGA.initialize('UA-122227697-1');
    const jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles) {
      jssStyles?.parentElement?.removeChild(jssStyles);
    }
  }, []);

  return (
    <div className={classes.paperStyles}>
      <ThemeProvider theme={Theme}>
        <NamesProvider>
          <Component {...pageProps} key={router.route} />
          <CssBaseline />
        </NamesProvider>
      </ThemeProvider>
    </div>
  );
}
